module.exports = __webpack_public_path__ + "img/compare.8fc549f8.png";